export default __webpack_public_path__ + "static/appstore-02c99c093dde5c4c462b1c7e07ca71ab.png";